import { render, staticRenderFns } from "./PiecesJointes.vue?vue&type=template&id=65e9e643"
import script from "./PiecesJointes.vue?vue&type=script&lang=js"
export * from "./PiecesJointes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports